import { Button, Grid } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const publicFooterPaths = [
  "/",
  "/about",
  "/about-us",
  "/how-it-works",
  "/pricing",
  "/privacy-policy",
];

const Footer = () => {
  const location = useLocation();
  if (publicFooterPaths.includes(location.pathname)) {
    return (
      <Grid
        item
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        sx={{ py: 2, flexWrap: "wrap" }}
      >
        <Button
          size="small"
          variant="text"
          component={Link}
          to="/about-us"
        >
          About Us
        </Button>
        <Button
          size="small"
          variant="text"
          component={Link}
          to="/privacy-policy"
        >
          Privacy Policy
        </Button>
      </Grid>
    );
  } else {
    return <></>;
  }
};

export default Footer;
